module.exports = __webpack_public_path__ + "img/group-3902@3x.ec728039.png";